export default "__VITE_ASSET__CuzaAPfL__"